import { Product } from 'schema-dts';
import { ReviewRatingStatistics } from 'shared/types/product/Product';
import { ExtendedVariant } from 'shared/types/product/Variant';
import { cloudinaryLoader } from '../../../components/commercetools-ui/atoms/image/loaders/cloudinary';
import { UIProduct } from '../../../components/commercetools-ui/organisms/product/product-details/types';
import { ReviewListProps } from '../../../components/commercetools-ui/organisms/review-list';
import { DEFAULT_CURRENCY } from "../../constants/ecommerce";

export const mapProductImages = (product: UIProduct) => {
  return product.images.reduce((previousValue, currentValue) => {
    if (currentValue.media?.mediaId) {
      previousValue.push(
        cloudinaryLoader({
          mediaId: currentValue.media?.mediaId,
          src: currentValue?.src ?? '',
          width: 500,
        }),
      );
    } else if (currentValue.src) {
      previousValue.push(currentValue.src);
    }

    return previousValue;
  }, [] as string[]);
};

export const mapProductRatings = (ratingData: ReviewRatingStatistics): Product['aggregateRating'] => {
  return {
    '@type': 'AggregateRating',
    ratingValue: ratingData.averageRating,
    reviewCount: ratingData.count,
  };
};

export const mapProductOffer = (
  product: UIProduct,
  variant: ExtendedVariant,
  finalBasePrice: number,
  origin?: string,
): Product['offers'] => {
  return {
    '@type': 'Offer',
    shippingDetails: {
      '@type': 'OfferShippingDetails',
      deliveryTime: {
        '@type': 'ShippingDeliveryTime',
        transitTime: {
          '@type': 'QuantitativeValue',
          minValue: variant?.leadTime,
          maxValue: variant?.leadTime,
          unitCode: 'd',
        },
        businessDays: {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: [
            'https://schema.org/Monday',
            'https://schema.org/Tuesday',
            'https://schema.org/Wednesday',
            'https://schema.org/Thursday',
            'https://schema.org/Friday',
          ],
        },
      },
    },
    ...(origin ? { url: `${origin}/${product.productKey}/p/${variant.sku}` } : {}),
    priceCurrency: product?.price?.currencyCode ?? DEFAULT_CURRENCY,
    price: (finalBasePrice ?? 0) / 100,
    availability: variant.isAvailable ? 'https://schema.org/InStock' : 'https://schema.org/OutOfStock',
  };
};

export const mapProductReview = (reviews: ReviewListProps): Product['review'] => {
  return reviews.reviews.map((review) => ({
    '@type': 'Review',
    // ISO 8601 date format 2025-04-28
    datePublished: review.createdAt,
    reviewBody: review.description,
    reviewRating: {
      '@type': 'Rating',
      ratingValue: review.rating,
    },
    author: {
      '@type': 'Person',
      name: review.author,
    },
  }));
};
